export const routes = {
  analytics: '/analytics',
  agentAnalytics: 'agent-analytics',
  callEvaluation: 'call-evaluation',
  callAuditing: 'call-auditing',
  // dashboard: '/AIAgent',
  login: '/login',
  signup: '/signup',
  termsAndConditions: '/terms-and-conditions',
  privacyPolicy: '/privacy-policy',
  resetPassword: '/password/reset/:token',
  resetPasswordSuccess: '/verification/p/:token',
  phoneNumber: '/phone-numbers',
  voiceLibrary: '/voice-library',
  knowledgeBase: '/knowledge-base',
  restaurantMenuConfig: '/knowledge-base/restaurant-menu',
  generalSupport: '/knowledge-base/general-support',
  reservation: '/knowledge-base/reservation',
  manageUsers: '/manage-users',
  calls: '/calls',
  call: '/calls/:id',
  whatsAppLogs: '/whatsapp-logs',
  orderManagment: '/order-management',
  mailVerify: '/account/verify/:token',
  storeManagement: '/store-management',
  billing: '/billing',
  reservationManagement: '/reservation-management',
  addNewAssistant: '/add-new-assistant',
  addNewAssistantTemplate: '/add-new-assistant/:templateName',
  agentCreation: '/agent-creation',
  setUpBusiness: '/set-up-business',
  onboarding: '/onboarding',
  agent: '/agent/:agentName',
  agents: '/',
  brandManagement: '/brand-management',
  customerManagement: '/customer-management',
  whatsappChats: '/whatsapp-chats',
  whatsappChatByPhone: '/whatsapp-chats/:whatsappPhonenumberId/:phoneNumber',
  promptCompare: '/prompt-compare/:agentId/:versionId1/:versionId2',
  callStage: '/call-stage/:agentId',
  userProfile: '/user-profile',
  quibbleFlows: '/workflows',
  campaign: '/campaign',
  quibbleFlow: '/workflows/:flowPath',
  quibbleFlowDetail: '/workflows/:flowPath/:jobId',
  serverLogs: '/server-logs/:agentId/:callId',
  acceptInvite: '/accept-invite',
  integration: '/integrations',
};
